<template>
  <el-footer style="padding: 5px" class="myfont">
    <span class="copyright">Copyright &copy; CoV2-TCR 2022</span>
    <span class="copyright">Shanghai Institute for Biomedical and Phamaceutical Technologies.</span>
  </el-footer>
</template>

<script>
export default {

}
</script>

<style>
.copyright{
  margin: 0 15px;
  color:rgb(245, 245, 245);
  font-weight: normal;
}
</style>